import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTriangleDownSmall"><Path d="M10.0869 10.5C9.23254 10.5 8.77163 11.5021 9.32764 12.1508L11.2405 14.3825C11.6396 14.8481 12.3599 14.8481 12.759 14.3825L14.6719 12.1508C15.2279 11.5021 14.767 10.5 13.9127 10.5H10.0869Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownSmall;
